var rng = {};

export { rng as __exports };
//# sourceMappingURL=rng.js.map
